import React, { useEffect, useRef, useState } from 'react';
import * as Yup from "yup";
import { Form, Formik } from 'formik';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Breadcrumbs from '../../../components/BreadCrumbs';
import InputField from '../../../components/inputFields/InputField';
import FormikDropdown from '../../../components/inputFields/FormikDropDown';
import Button from '../../../components/buttons/Button';
import StyledHeadingText from '../../../components/Fonts/StyledHeadingText';
import { addHudPatientPackageInvoice } from '../../../services/hud/hud_patients';
import { addNewHudPatientPackageInvoice } from '../../../services/new_clinic/new_hud_patients';
import { sendInvoiceVericifationOtp } from '../../../services/clinic/invoice';

function NewAddPatientPackageInvoice() {
    const location = useLocation();
    const navigate = useNavigate();
    const [rowData, setRowData] = useState({});
    const [otpText, setOtpText] = useState("");
    const [responseOtp, setResponseOtp] = useState(null);
    const [showOverlay, setShowOverlay] = useState(false);


    const handleFormSubmit = async (values, { setSubmitting }) => {
        try {
            const formData = new FormData();
            formData.append("package", rowData.id);
            formData.append("amount", values.amount);
            formData.append("mode", values.mode);
            formData.append("transaction_no", values.transaction_number);
            formData.append("remark", values.remark);
            formData.append("package_type", rowData.package_name);
            const response = await addNewHudPatientPackageInvoice(formData);

            if (response?.status === 201) {
                toast.success("Invoice Generated successfully!");
                navigate(-1);
            } else {
                let errors = "Opps! Something went wrong, please try again.";
                toast.error(errors);
            }
        } catch (error) {
            let errors =
                error?.response?.data?.error ||
                "Opps! Something went wrong, please try again.";
            toast.error(errors);
        }
        setSubmitting(false);
    };

    const handleDiscardChanges = (resetForm) => {
        resetForm(); // Reset the form
        navigate(-1);
    };

    useEffect(() => {
        const patientData = location.state;
        if (patientData) {
            setRowData(patientData);
        } else {
            toast.error("Error while looking for patient");
            navigate(-1);
        }
    }, [location.state]);


    const handleOtpSend = async (values) => {
        try {
            const formData = new FormData();
            formData.append("mobile_number", values.alternate_phone);
            const response = await sendInvoiceVericifationOtp(formData);

            if (response?.status === 200) {
                toast.success("OTP Sent successfully!");
                setResponseOtp(response.data.otp);
            } else {
                let errors = "Opps! Something went wrong, please try again.";
                toast.error(errors);
            }
        } catch (error) {
            let errors =
                error?.response?.data?.error ||
                "Opps! Something went wrong, please try again.";
            toast.error(errors);
        }
    };

    const handleOtpFill = (value) => {
        if (value) {
            if (otpText.length !== 0) {
                if (otpText.length < 4) {
                    setOtpText(otpText + value);
                }
            } else {
                setOtpText(value);
            }
        } else {
            let updatedText = otpText.slice(0, -1);
            setOtpText(updatedText);
        }
    };

    return (
        <>
            <Breadcrumbs items={[
                { name: 'Home', link: '/package-invoice' },
                { name: 'Patients', link: '/new-hud-patients' },
                { name: 'Patient Packages' },
                { name: 'Add Invoice' },
            ]} />
            <div className="mt-8">
                <Formik
                    initialValues={{
                        amount: "",
                        mode: "UPI",
                        transaction_number: "",
                        remark: "",
                        otp: "",
                        alternate_phone: rowData?.mobile_number ?? "",
                    }}
                    validationSchema={Yup.object({
                        amount: Yup.number()
                            .required("Please enter an amount")
                            .positive("Amount must be positive")
                            .integer("Amount must be an integer")
                            .min(0, "Minimum should be 0"),
                        // .max(rowData.remaining_amount || 0,
                        //     `Max ₹${(rowData.remaining_amount || 0)} is allowed`
                        // ),
                        mode: Yup.string().required("Please select a payment mode"),
                    })}
                    onSubmit={handleFormSubmit}
                    enableReinitialize
                >
                    {({ isSubmitting, setFieldValue, resetForm, values }) => (
                        <Form>
                            <div className="border border-gray-300 mt-5 p-4 rounded-lg bg-gray-100 flex flex-col gap-4">
                                <StyledHeadingText text={"Package: " + rowData.package_name + " | Rem. Am: ₹" + rowData.remaining_amount} />
                                <div className="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-0.5">
                                    <InputField
                                        label="Amount"
                                        name="amount"
                                        type="text"
                                        placeholder="Enter Amount"
                                        required
                                    />
                                    <FormikDropdown
                                        label="Mode"
                                        name="mode"
                                        placeholder="Select Mode"
                                        required={true}
                                        options={[
                                            { label: "NEFT", value: "NEFT" },
                                            { label: "Cash", value: "Cash" },
                                            { label: "UPI", value: "UPI" },
                                            { label: "Card", value: "Card" },
                                        ]}
                                    />
                                    {
                                        values.mode === "Cash" && (
                                            <InputField
                                                label="Alt. Phone"
                                                name="alternate_phone"
                                                type="text"
                                                placeholder="Enter Phone Number"
                                                className={responseOtp ? "" : "hidden"}
                                                required
                                            />
                                        )
                                    }
                                    {
                                        values.mode === "UPI" || values.mode === "Card" ?
                                            <InputField
                                                label={values.mode === "UPI" ? "UPI Number" : "Card Number"}
                                                name="transaction_number"
                                                placeholder={values.mode === "UPI" ? "Enter UPI Number" : "Enter Card Number"}
                                            /> : <></>
                                    }
                                    {
                                        values.mode === "Cash" ?
                                            <div className="flex flex-col pb-2 justify-end">
                                                <Button
                                                    type="button"
                                                    className="text-primary bg-white hover:bg-white-dark font-sm rounded-lg text-lg w-full px-8 py-1.5 text-center border border-primary"
                                                    onClick={() => handleOtpSend(values)}>
                                                    Generate OTP
                                                </Button>
                                            </div>
                                            : <></>
                                    }
                                    {
                                        values.mode === "Cash" ?
                                            <InputField
                                                label="OTP"
                                                name="otp"
                                                placeholder={"Enter OTP"}
                                                type="number"
                                                value={otpText}
                                                onChange={(val) => handleOtpFill(val.nativeEvent.data)}
                                                required
                                            />
                                            : <></>
                                    }
                                    <InputField
                                        label="Remark"
                                        name="remark"
                                        type="text"
                                        placeholder="You can add a remark here"
                                    />
                                </div>
                            </div>
                            <div className="py-5 flex justify-end gap-6">
                                <div>
                                    <Button
                                        type="button"
                                        className="text-primary bg-white hover:bg-white-dark font-sm rounded-lg text-lg w-full px-8 py-1.5 text-center border border-primary"
                                        onClick={() => handleDiscardChanges(resetForm)}
                                        disabled={isSubmitting}
                                    >
                                        Discard Changes
                                    </Button>
                                </div>
                                <div>
                                    <Button
                                        type="submit"
                                        className="text-white bg-primary hover:bg-primary-dark font-sm rounded-lg text-lg w-full px-8 py-1.5 text-center"
                                        disabled={isSubmitting}
                                    >
                                        {isSubmitting ? "Saving..." : "Save"}
                                    </Button>
                                </div>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        </>
    );
}

export default NewAddPatientPackageInvoice;
